'use client';

import { memo } from 'react';

import { useClipboard } from '@/hooks/useClipboard';

import { MAP_INFO } from '../constants';

export const AddressInfoClient = memo(() => {
  const copyToClipboard = useClipboard();

  const handleCopyAddress = () => {
    copyToClipboard({
      value: MAP_INFO.address,
      message: '주소를 복사했어요',
    });
  };

  const handleCopyTransport = () => {
    copyToClipboard({
      value: MAP_INFO.transport,
      message: '교통 안내를 복사했어요',
    });
  };

  return (
    <div className="flex w-full flex-col gap-16">
      <div className="flex w-full flex-col gap-2">
        <p className="font-600 text-Gray-white typo-body3">주소</p>
        <div className="flex gap-8 typo-body4">
          <p className="text-Gray-550">{MAP_INFO.address}</p>
          <button
            type="button"
            onClick={handleCopyAddress}
            className="cursor-pointer text-Gray-white underline decoration-solid"
          >
            복사
          </button>
        </div>
      </div>

      <div className="flex w-full flex-col gap-2">
        <p className="font-600 text-Gray-white typo-body3">교통 안내</p>
        <div className="flex gap-8 typo-body4">
          <p className="text-Gray-550">{MAP_INFO.transport}</p>
          <button
            type="button"
            onClick={handleCopyTransport}
            className="cursor-pointer text-Gray-white underline decoration-solid"
          >
            복사
          </button>
        </div>
      </div>
    </div>
  );
});

AddressInfoClient.displayName = 'AddressInfoClient';
